const VIDEO_ANALYTIC_OVERLAY_COLOR_STORAGE_KEY = 'pointVideoAnalyticOverlayColor';
const VIDEO_ANALYTIC_OVERLAY_COLORS = ['black', 'positive', 'negative', 'blue'] as const;

export type VideoAnalyticOverlayColor = typeof VIDEO_ANALYTIC_OVERLAY_COLORS[number];

export const DEFAULT_VIDEO_ANALYTIC_OVERLAY_COLOR: VideoAnalyticOverlayColor = 'negative';

function isVideoAnalyticOverlayColor(value: string | null): value is VideoAnalyticOverlayColor {
  return value !== null
    && VIDEO_ANALYTIC_OVERLAY_COLORS.includes(value as VideoAnalyticOverlayColor);
}

export function getSavedVideoAnalyticOverlayColor(): VideoAnalyticOverlayColor {
  try {
    const savedColor = localStorage.getItem(VIDEO_ANALYTIC_OVERLAY_COLOR_STORAGE_KEY);

    return isVideoAnalyticOverlayColor(savedColor)
      ? savedColor
      : DEFAULT_VIDEO_ANALYTIC_OVERLAY_COLOR;
  } catch {
    return DEFAULT_VIDEO_ANALYTIC_OVERLAY_COLOR;
  }
}

export function saveVideoAnalyticOverlayColor(color: VideoAnalyticOverlayColor): void {
  if (!isVideoAnalyticOverlayColor(color)) return;

  try {
    localStorage.setItem(VIDEO_ANALYTIC_OVERLAY_COLOR_STORAGE_KEY, color);
  } catch {
    // Ignore storage errors and keep the in-memory selection.
  }
}
